import { Group, Select } from '@mantine/core';

import { SCHOOLS, firstGrade, gradeOptions, type School } from '../lib/school';

export type SchoolValue = { school: School; grade: number };

/** What the form holds: the school type may be open still, when the app would
 * otherwise have to guess it (after grade 4). */
export type SchoolDraft = { school: School | null; grade: number };

// The school type and the grade, side by side. Changing the school type moves
// the grade into its range, so the pair the form holds is always one the
// server accepts.
export function SchoolFields({
  value,
  onChange,
}: {
  value: SchoolDraft;
  onChange: (v: SchoolValue) => void;
}) {
  return (
    <Group grow align="flex-start">
      <Select
        label="Schulform"
        placeholder="Schulform wählen"
        data={SCHOOLS.map((s) => ({ value: s.value, label: s.label }))}
        value={value.school}
        allowDeselect={false}
        onChange={(v) => {
          if (!v) return;
          const school = v as School;
          const s = SCHOOLS.find((x) => x.value === school)!;
          const grade = value.grade >= s.first && value.grade <= s.last ? value.grade : firstGrade(school);
          onChange({ school, grade });
        }}
      />
      <Select
        label="Klasse"
        disabled={!value.school}
        data={
          value.school
            ? gradeOptions(value.school)
            : [{ value: String(value.grade), label: `Klasse ${value.grade}` }]
        }
        value={String(value.grade)}
        allowDeselect={false}
        onChange={(v) => v && value.school && onChange({ school: value.school, grade: Number(v) })}
      />
    </Group>
  );
}
